import { render, staticRenderFns } from "./ReportesCreditoList.vue?vue&type=template&id=165106b5&scoped=true&lang=html&"
import script from "./ReportesCreditoList.vue?vue&type=script&lang=js&"
export * from "./ReportesCreditoList.vue?vue&type=script&lang=js&"
import style0 from "./ReportesCreditoList.vue?vue&type=style&index=0&id=165106b5&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165106b5",
  null
  
)

export default component.exports